import { api } from '../client/axiosClient';
import { CustomResponseEntity } from '../types/common';
import { DataTypeDto, CreateDataTypeDto, UpdateDataTypeDto } from '../types/dtos/DataTypeDto';

/**
 * DataType Service - System-wide content type definitions
 * Note: Unlike other endpoints, Data Types are NOT scoped to organizations
 */
export class DataTypeService {
  private baseUrl = '/api/v1/datatype';

  /**
   * Get all active data types
   */
  async findAll(): Promise<CustomResponseEntity<DataTypeDto[]>> {
    const response = await api.get<CustomResponseEntity<DataTypeDto[]>>(this.baseUrl);
    return response; // Return full response, axios interceptor already unwrapped it
  }

  /**
   * Get a single data type by ID
   */
  async findById(id: string): Promise<CustomResponseEntity<DataTypeDto>> {
    const response = await api.get<CustomResponseEntity<DataTypeDto>>(`${this.baseUrl}/${id}`);
    return response; // Return full response, axios interceptor already unwrapped it
  }

  /**
   * Create a new data type
   */
  async create(data: CreateDataTypeDto): Promise<CustomResponseEntity<DataTypeDto>> {
    const response = await api.post<CustomResponseEntity<DataTypeDto>>(this.baseUrl, data);
    return response; // Return full response, axios interceptor already unwrapped it
  }

  /**
   * Update an existing data type
   */
  async update(id: string, data: UpdateDataTypeDto): Promise<CustomResponseEntity<DataTypeDto>> {
    const response = await api.put<CustomResponseEntity<DataTypeDto>>(`${this.baseUrl}/${id}`, data);
    return response; // Return full response, axios interceptor already unwrapped it
  }

  /**
   * Delete a data type (soft delete)
   */
  async delete(id: string): Promise<CustomResponseEntity<null>> {
    const response = await api.delete<CustomResponseEntity<null>>(`${this.baseUrl}/${id}`);
    return response; // Return full response, axios interceptor already unwrapped it
  }
}

export const dataTypeService = new DataTypeService();

